import { createContext } from 'react';

const contextValues = {
  cuid: '',
};

const ChildContext = createContext(contextValues);

const MemberContext = createContext();

const BalanceContext = createContext();

export {
  ChildContext,
  MemberContext,
  BalanceContext,
};
